import { trpc } from '@/utils/trpc'
import { useState } from 'react'
import showToastNotification from './useShowToast'

const useInviteUserToTeam = () => {
  const [emailToInvite, setEmailToInvite] = useState<string>('')
  const [role, setRole] = useState<'creator' | 'commenter'>('commenter')

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const isEmailValid = emailRegex.test(emailToInvite)
  const utils = trpc.useUtils()

  const { mutate: inviteUsers, isPending } = trpc.inviteUsers.useMutation({
    onSuccess: async () => {
      showToastNotification('success', {
        message: `Success`,
        description: `Invites sent successfully!`,
      })
      utils.teamInvitees.invalidate()
      setEmailToInvite('')
    },
    onError: () => {
      showToastNotification('error', {
        message: `Failed to invite users`,
        description: `Unfortunately, we couldn't send the invites. Please try again later.`,
      })
    },
  })

  return {
    emailToInvite,
    setEmailToInvite,
    role,
    setRole,
    isEmailValid,
    inviteUsers,
    isPending,
  }
}
export default useInviteUserToTeam
